import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import DrawerCustom from '../component/Drawer';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import BlockedNumberTable from './BlockedNumberTable';
import { Divider } from '@mui/material';




export default function ConfigurationAO() {
   
  return (
 <Box sx={{ display: 'flex' }}>
    <CssBaseline />
    <DrawerCustom />
    <Box component="main" >
    <Grid xs={12}> 
    <Typography variant="h3" sx={{ marginTop: 5 }}>Auction Services Configurations</Typography>
    <Divider sx={{ marginBottom: 2, width: '55%' }} />
    <Typography className="uiSubHeaderFont" sx={{ fontSize: 18,  width: '85%' }}>
        Configurations for the Auction Services team to add blocked numbers to the AS Blocked Number Data Table within Genesys Cloud.{" "}
    </Typography>
    </Grid> 
    <Grid xs={12}> 
    <BlockedNumberTable />
    </Grid>  
  </Box>
</Box>
  );
}